export class CalculationMethodAntiFraudSend
{
    PaymentRequestID: number;
}